import { render } from "./catalog.vue?vue&type=template&id=d72d7008&scoped=true"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"

import "./catalog.vue?vue&type=style&index=0&id=d72d7008&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72d7008"]])

export default __exports__